import "./App.css";
import { Navigate, Route, Routes } from "react-router-dom"; // Use Navigate instead of Redirect
import AdminLayout from "./layouts/layout";
import Users from "./pages/users/users";
import Login from "./pages/login/login";

import useAuth from "./hooks/useAuth";
import { Spin } from "antd";
import Profile from "./pages/profile/profile";
import SubscriptionPlans from "./pages/subscriptionPlans/subscriptionPlans";
import ProtectedRoute from "./components/general/protectedRoute/protectedRoute";
import ForbiddenPage from "./pages/forbidden-page/forbiddenPage";
import Subscriptions from "./pages/subscriptions/subscriptions";
import ManageSubscriptions from "./pages/manageSubscriptions/manageSubscriptions";
import Payments from "./pages/payments/payments";
import RecoverPassword from "./pages/recoverPassword/recoverPassword";
import Map from "./pages/map/map";
import Reports from "./pages/reports/reports";
import OceanReportsHub from "./pages/reports/OceanReportsHub";
import RolesManagement from "./pages/roles/RolesManagement";
import Dashboard from "./pages/dashboard/dashboard";
import SystemParameters from "./pages/systemParameters/SystemParameters";

function App() {
  const auth = useAuth();

  return (
    <div className="App">
      {auth.userLoading ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        <Routes>
          <Route
            path="login"
            element={
              auth.isAuthenticated ? <Navigate to="/admin/profile" /> : <Login />
            }
          />

          <Route path={"/forgot-password"} element={<RecoverPassword />} />
          <Route
            path="/admin"
            element={
              auth.isAuthenticated ? <AdminLayout /> : <Navigate to="/login" />
            }
          >
            <Route
              path="map/1"
              element={
                <ProtectedRoute
                  requiredPermission={"ui:map:point"}
                  redirectTo={"/admin/profile"}
                >
                  <Map index={1} />
                </ProtectedRoute>
              }
            />
            <Route
              path="map/2"
              element={
                <ProtectedRoute
                  requiredPermission={"ui:map:transect"}
                  redirectTo={"/admin/profile"}
                >
                  <Map index={2} />
                </ProtectedRoute>
              }
            />

            <Route
              path="users"
              element={
                <ProtectedRoute
                  requiredPermission={"ui:users:view"}
                  redirectTo={"/admin/profile"}
                >
                  <Users />
                </ProtectedRoute>
              }
            />
            <Route
              path="dashboard"
              element={
                <ProtectedRoute
                  requiredPermission={"ui:dashboard:view"}
                  redirectTo={"/admin/profile"}
                >
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="roles"
              element={
                <ProtectedRoute
                  requiredPermission={"ui:roles:view"}
                  redirectTo={"/admin/profile"}
                >
                  <RolesManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path={"profile"}
              element={
                <ProtectedRoute requiredPermission={"ui:profile:view"}>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path={"subscription-plans"}
              element={
                <ProtectedRoute
                  requiredPermission={"ui:subscription-plans:view"}
                  redirectTo={"/admin/subscriptions"}
                >
                  <SubscriptionPlans />
                </ProtectedRoute>
              }
            />
            <Route
              path={"subscriptions"}
              element={
                <ProtectedRoute requiredPermission={"ui:subscriptions:view"}>
                  <Subscriptions />
                </ProtectedRoute>
              }
            />
            <Route
              path={"manage-subscriptions"}
              element={
                <ProtectedRoute requiredPermission={"ui:subscriptions:manage"}>
                  <ManageSubscriptions />
                </ProtectedRoute>
              }
            />
            <Route
              path={"payments"}
              element={
                <ProtectedRoute requiredPermission={"ui:purchases:view"}>
                  <Payments />
                </ProtectedRoute>
              }
            />
            {/* HUB de boletines — entrada principal */}
            <Route
              path={"reports"}
              element={
                <ProtectedRoute requiredPermission={"ui:newsletter"} redirectTo={"/admin/profile"}>
                  <OceanReportsHub />
                </ProtectedRoute>
              }
            />
            {/* Ruta directa a boletín específico por país y sección */}
            <Route
              path={"reports/:country/:section?"}
              element={
                <ProtectedRoute requiredPermission={"ui:newsletter"}>
                  <Reports />
                </ProtectedRoute>
              }
            />

            <Route
              path={"system-parameters"}
              element={
                <ProtectedRoute requiredPermission={"ui:system:config"}>
                  <SystemParameters />
                </ProtectedRoute>
              }
            />
          </Route>

          <Route path={"/forbidden"} element={<ForbiddenPage />} />
          <Route
            path="*"
            element={
              <Navigate to={auth.isAuthenticated ? "/admin/profile" : "/login"} />
            }
          />
        </Routes>
      )}
    </div>
  );
}

export default App;
